module.exports = __webpack_public_path__ + "images/Timer.07aee0d8b08e718746ddb7d96427b302.svg";